import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  deleting: false,
  data: [],
  errorMessage: '',
  paginatedElements: 0,
  searchTerm: '',
  initialData: [],
  marker_data: [],
  markerFilter: false,
};

const assetMapReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.ASSETS_MAP_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };
    case REDUX_ACTIONS.ASSETS_MAP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.data],
        initialData: [...action.payload.data],
        paginatedElements: action.payload.paginatedElements,
        errorMessage: '',
        marker_data: [...action.payload.data],
      };
    case REDUX_ACTIONS.ASSETS_MAP_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: [],
        marker_data: []
      };
    case REDUX_ACTIONS.ASSETS_MAP_SEARCH_CHANGE:
      return {
        ...state,
        searchTerm: action.payload.value,
      };
    case REDUX_ACTIONS.ASSETS_MAP_FILTER:
      return {
        ...state,
        data: [
          ...state.initialData.filter((item) => {
            const searchTerm = state.searchTerm.toUpperCase();
            return (
              item.Rig.toUpperCase().includes(searchTerm) ||
                    item.Well.toUpperCase().includes(searchTerm) ||
                        item.SN.toUpperCase().includes(searchTerm)
            );
          }),
        ],
        marker_data: [
          ...state.initialData.filter((item) => {
            const searchTerm = state.searchTerm.toUpperCase();
            return (
              item.Rig.toUpperCase().includes(searchTerm) ||
                    item.Well.toUpperCase().includes(searchTerm) ||
                        item.SN.toUpperCase().includes(searchTerm)
            );
          }),
        ],
        markerFilter: false
      };
    case REDUX_ACTIONS.ASSETS_MAP_MARKER_FILTER:
      return {
        ...state,
        marker_data: [
          ...action.payload.data
        ],
        markerFilter: true
      };
    case REDUX_ACTIONS.ASSETS_MAP_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default assetMapReducer;
